/**
 * CSS custom property references for dynamic UI bindings in TypeScript/HTML.
 * Values are var() references — not hex — so runtime theme changes propagate.
 * Part of AppTheme (see app-theme.ts) alongside logo branding.
 */
export const ThemeTokens = {
  primary: 'var(--saferoads-primary)',
  primaryDark: 'var(--saferoads-primary-dark)',
  secondary: 'var(--saferoads-secondary)',
  accent: 'var(--saferoads-accent)',
  background: 'var(--saferoads-background)',
  surface: 'var(--saferoads-surface)',
  text: 'var(--saferoads-text)',
  textPrimary: 'var(--saferoads-text-primary)',
  textBody: 'var(--saferoads-text-body)',
  textSecondary: 'var(--saferoads-text-secondary)',
  textMuted: 'var(--saferoads-text-muted)',
  textInverse: 'var(--saferoads-text-inverse)',
  border: 'var(--saferoads-border)',
  success: 'var(--saferoads-success)',
  warning: 'var(--saferoads-warning)',
  error: 'var(--saferoads-error)',
  errorAlt: 'var(--saferoads-error-alt)',
  info: 'var(--saferoads-info)',
  neutral400: 'var(--saferoads-neutral-400)',
  neutral500: 'var(--saferoads-neutral-500)',
  grayDisabled: 'var(--saferoads-gray-disabled)',
  light: 'var(--saferoads-light)',
  dark: 'var(--saferoads-dark)',
} as const;

export type ThemeToken = (typeof ThemeTokens)[keyof typeof ThemeTokens];
